export default "__VITE_ASSET__0d988063__"